export default "__VITE_ASSET__BH6E79K4__"